/* global G */
import { curry } from 'lib/util'

const descriptor = 'model::decorator::fromSingleRef'

/**
 * key attribute should be a single ref model
 *
 * @param {string} key          the name of the attribute to get the data from
 * @param {string} target       the name of the attribute to store the data to
 * @param {Gaia.Model.Spec} obj the current model object composition
 * @param {Object} component    the component that matched the attribute name during the mapping
 * @returns {Object}
 */
const fn = (key, target, obj, component) => {
  console.warn(descriptor, key, target)

  const source = obj[G.CHILDREN][key]
  const value = source[G.CACHE] ? source[G.CACHE][0] : source[G.CACHE]
  const item = obj[G.CHILDREN][target]
  
  item[G.CACHE] = value ? [value] : value // moving to cache, so map() can do it's thing

  return component
}

export default curry(fn)
